import React from "react";
import logo from "../../assests/images/logo2.png";
import "./Footer.css";

const Footer = () => (
  <footer className="tb-footer">
    <div className="tb-container">
      <div className="tb-footer-top">
        <div className="tb-footer-brand">
          <a className="tb-footer-logo" href="/" aria-label="Touza Bilar – startsidan">
            <img src={logo} alt="Touza Bilar AB" width="178" height="95" loading="lazy" />
          </a>
          <p>Ditt nästa kapitel börjar bakom ratten.<br />Köper, säljer och byter bilar i Södertälje.</p>
        </div>
        <nav className="tb-footer-nav" aria-label="Sidfotsmeny">
          <h2>Utforska</h2>
          <a href="https://www.blocket.se/butik/touza-bilar">Bilar i lager <span aria-hidden="true">↗</span></a>
          <a href="/about">Om oss</a>
          <a href="/#contact">Kontakta oss</a>
          <a href="https://www.instagram.com/touzabilarab/">Instagram <span aria-hidden="true">↗</span></a>
        </nav>
        <div className="tb-footer-contact">
          <h2>Besök & kontakt</h2>
          <a href="tel:+46855066158">08-550 66 158</a>
          <address>Wedavägen 4C<br />152 42 Södertälje</address>
          <a className="tb-footer-map" href="https://www.google.com/maps/dir/?api=1&destination=Wedav%C3%A4gen%204C%2C%20152%2042%20S%C3%B6dert%C3%A4lje">Hitta hit <span aria-hidden="true">↗</span></a>
        </div>
        <div className="tb-footer-hours">
          <h2>Öppettider</h2>
          <dl>
            <div><dt>Måndag–fredag</dt><dd>09:30–17:30</dd></div>
            <div><dt>Lördag</dt><dd>11:00–15:00</dd></div>
          </dl>
        </div>
      </div>
      <div className="tb-footer-bottom">
        <p>© {new Date().getFullYear()} Touza Bilar AB</p>
        <p>Köper <span aria-hidden="true">·</span> Säljer <span aria-hidden="true">·</span> Byter</p>
      </div>
    </div>
  </footer>
);

export default Footer;